export interface ProfileEntryBase {
  date: string;
  link: string;
  location: string;
}

export interface JobEntry extends ProfileEntryBase {
  type: 'job';
  position: string;
  company: string;
}

export interface EducationEntry extends ProfileEntryBase {
  type: 'education';
  degree: string;
  institution: string;
}

export type ProfileEntry = JobEntry | EducationEntry;

export default [
  {
    type: 'job',
    position: 'Staff Software Engineer (Data Experience)',
    company: 'Airbnb',
    link: 'https://airbnb.com',
    location: 'San Francisco, CA, USA',
    date: '2023-present',
  },
  {
    type: 'job',
    position: 'Engineering Manager (Data Experience)',
    company: 'Airbnb',
    link: 'https://airbnb.com',
    location: 'San Francisco, CA, USA',
    date: '2019-2023',
  },
  {
    type: 'job',
    position: 'Staff Software Engineer (Data Experience)',
    company: 'Airbnb',
    link: 'https://airbnb.com',
    location: 'San Francisco, CA, USA',
    date: '2018-2019',
  },
  {
    type: 'job',
    position: 'Staff Data Scientist (Visualization)',
    company: 'Twitter',
    link: 'https://twitter.com',
    location: 'San Francisco, CA, USA',
    date: '2012-2018',
  },
  {
    type: 'education',
    degree: 'Ph.D. in Computer Science',
    institution: 'University of Maryland',
    link: 'http://www.cs.umd.edu/',
    location: 'College Park, MD, USA',
    date: '2007-2012',
  },
  {
    type: 'job',
    position: 'Research Intern',
    company: 'IBM T.J. Watson Research Center',
    link: 'http://www.research.ibm.com/',
    location: 'Hawthorne, NY, USA',
    date: 2011,
  },
  {
    type: 'job',
    position: 'Research Intern',
    company: 'Microsoft Research',
    link: 'http://research.microsoft.com/',
    location: 'Redmond, WA, USA',
    date: 2010,
  },
  {
    type: 'education',
    degree: 'M.S. in Computer Science',
    institution: 'University of Maryland',
    link: 'http://www.cs.umd.edu/',
    location: 'College Park, MD, USA',
    date: '2007-2009',
  },
  {
    type: 'job',
    position: 'System Analyst',
    company: 'ITOne Co.,Ltd.',
    link: 'http://www.itoneco.com/',
    location: 'Bangkok, Thailand',
    date: 2007,
  },
  {
    type: 'education',
    degree: 'B.Eng in Computer Engineering (1st-class)',
    institution: 'Chulalongkorn University',
    link: 'http://www.eng.chula.ac.th/',
    location: 'Bangkok, Thailand',
    date: '2003-2007',
  },
  {
    type: 'job',
    position: 'Software Developer Intern',
    company: 'The Stock Exchange of Thailand',
    link: 'http://www.settrade.com/',
    location: 'Bangkok, Thailand',
    date: 2006,
  },
] as ProfileEntry[];
